module.exports = __webpack_public_path__ + "static/sc_6-5ff987fb5f8ac52f0dfb02abb87ee4d6.jpg";